































import { Component, Vue, Prop } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import Question from '@/apps/open/components/Question'
import AddOrRemove from '@/apps/open/components/AddOrRemove'
import { ElForm } from 'element-ui/types/form'

const DOMAIN_COUNT_LIMIT = 3 // 最多设置三个域名白名单

@Component({
  componentName: 'EditDomainWhitelistDialogBody',
  components: {
    Button,
    Question,
    AddOrRemove
  }
})
export default class EditDomainWhitelistDialogBody extends Vue {
  @Prop()
  domainList!: string[]

  @Prop()
  submitCount!: number

  @Prop({
    default: false
  })
  submitting?: boolean

  @Prop()
  appId?: string

  @Prop()
  onCancel!: Function

  @Prop()
  onOk!: Function

  $refs!: {
    form: ElForm
  }

  get addAble () {
    return this.form.domainList.length < DOMAIN_COUNT_LIMIT
  }

  get disabledSubmit () {
    return this.form.domainList.some(i => i === '')
  }

  get settingFileUrl () {
    return `/serviceapi/openapi/domain/${this.appId}/settingsfile`
  }

  form = {
    domainList: this.domainList
  }

  rules = [
    { required: true, message: '请输入域名' }
  ]

  addDomain () {
    this.form.domainList.push('')
  }

  removeDomain (index: number) {
    this.form.domainList.splice(index, 1)
  }

  onSubmit () {
    this.$refs.form.validate((valid) => {
      this.onOk(this.form.domainList)
    })
  }
}
